import React,  { useCallback, useState, useEffect, useRef, useMemo } from 'react';
import FielderConst from 'FielderUtils/fielderConst';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import TaskStatus from 'FielderUtils/status/taskStatus';
import Select from 'react-select';
import Grid from '@mui/material/Grid2';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import SelectTaskType from './components/SelectTaskType';
import TaskVariables from './components/TaskVariables';
import TaskCaseNumber from './components/TaskCaseNumber';
import MapStaticComponent from '~/MapStatic/MapStatic.component';
import StaticMarker from '~/MapStatic/components/StaticMarker';
import GoogleMapsAutocomplete from '~/GoogleMapsAutocomplete/GoogleMapsAutocomplete.component';
import dayjs from 'dayjs';
import TaskPriority from './components/TaskPriority';
import EditTaskField from './EditTaskField';
import TaskExecutionDates from './components/TaskExecutionDates';
import TaskTags from './components/TaskTags';
import { Alert, Box, Button, Paper } from '@mui/material';
import {
	getBranchesByFilterAsyncSelectCreateTask,
	getBranchesInitialOptionsAsyncSelect,
} from 'FielderUtils/branch/branch';
import { getDefaultPriorities } from 'FielderUtils/Constants/TaskPriorityConstants';
import { getClientsByFilterAsyncSelect, getClientInitialOptionsAsyncSelect } from 'FielderUtils/client/client';
import { setKey, fromLatLng } from "react-geocode";
import { GOOGLE_API_KEY, getIdToken } from 'FielderUtils/session/Session';
import { hasMailIntegrationFunctionality } from 'FielderUtils/task/taskFuntionalities';
import { hasTaskTypeFunctionality, getAccountTaskTypes, checkTaskTypeRouteVariables } from 'FielderUtils/taskType/taskType';
import { getTaskPriorityByOriginRequest }  from '@core/api/taskPriority/taskPriority.service';
import { getTeamsByFilterAsyncSelect, getTeamsInitialOptionsAsyncSelect } from 'FielderUtils/team/team';
import { updateTaskRequest } from '@core/api/task/task.service';
import { useSelector, useDispatch } from 'react-redux';
import { selectAccount, selectUser, selectSession } from '@core/store/modules/session/sessionSelectors';
import { useLanguage } from 'Context/LanguageContext';
import 'react-day-picker/dist/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import './CreateTask.css';


setKey(GOOGLE_API_KEY);
const EditorTask = (props) => {
	/***************************  Session & User   ********************************/
	const session = useSelector(selectSession);
	const user = useSelector(selectUser);
	const idAccount = session.user ? session.user.idAccount : 0;
	const idUser = session.user ? session.user.idUser : 0;

	/***************************  Validate functionalities and Roles   ********************************/
	const account = useSelector(selectAccount);
	const mailIntegrationFunctionality = hasMailIntegrationFunctionality(account.funcionalityPurchases);
	const taskTypeFunctionality = hasTaskTypeFunctionality(account.funcionalityPurchases);
	const isUserClient = RoleUtils.isUserClient(user);
	const isNotAClient = !RoleUtils.isUserClient(user);

	/***************************  Language & Dispatch   ********************************/
	const dispatch = useDispatch();
	const lan = useLanguage();
	
	/***************************  Task Info   ********************************/
	const task = props.taskInfo.task;
	const idTask = task.idTask;
	const idCustomTask = task.idCustom ? task.idCustom : '';

	console.log("task")
	console.log(task)
	/************************** Validate task *********************************/
	const validateShowTeam = (task.status == TaskStatus.REVIEW && task.serviceTypeId == FielderConst.TASK_BY_MAIL && RoleUtils.isUserManager(user)) ? true : false;
	const { partnerTaskRelations = [] } = task || {};
	const isOwner = partnerTaskRelations[0]?.idAccountOwner === account.id;
	const iAmNotPartner = partnerTaskRelations.length === 0 || isOwner;

	/***************************  States   ********************************/
	const [folio, setFolio] = useState(task.folio);
	const [caseNumber, setCaseNumber] = useState(task.caseNumber);
	const [defaultPriority, setDefaultPriority] = useState(task.severity);
	const [taskPriorities, setTaskPriorities] = useState(getDefaultPriorities(lan));
	const [executionDates, setExecutionDates] = useState([task.startDateTimeRange ? dayjs(task.startDateTimeRange) : null, task.endDateTimeRange ? dayjs(task.endDateTimeRange) : null]);
	const [description, setDescription] = useState(task.description);
	const [tags, setTags] = useState(task.tags);
	const [hasRouteVariables, setHasRouteVariables] = useState(false);

	/***************************  Refs   ********************************/
	const cbClientRef = useRef(null);
	const cbBranchRef = useRef(null);
	
	const numberCaseRef = useRef({});
	const priorityRef = useRef({});
	const executionDateRef = useRef(null);
	const tagsRef = useRef({});
	const routeVariablesRef = useRef(null);


	/***************************  Client-Branches / Branches ********************************/
	const hasBranches = !! user?.branches;
	const [showBranchSearch, setShowBranchSearch] = useState(!task?.user && (!isUserClient || hasBranches));
	const [showClientSearch, setShowClientSearch] = useState(!!task?.user && (!isUserClient || hasBranches));

	const setClientBranches = (branches = []) =>
		branches.map((branch) => {
			const { idCustom = '', name = '', company: { idCustom: companyIdCustom = '', name: companyName = '' } = {} } = branch;

			return {
				label: `${idCustom} ${name} ${companyIdCustom} ${companyName}`.trim(),
				value: branch,
			};
  	});
	
	const clientBranches = useMemo(() => {
		if (isUserClient && hasBranches) {
			return setClientBranches(user.branches);
		}
		return [];
	}, [isUserClient, hasBranches, user?.branches]);
	
	const validateBranchesArray = (idBranchAux) => {
  		return [idBranch].includes(idBranchAux);
	};

	const setClientBranchId = (event) => {
		const elements = [
			{ id: 'branch_data-alert-icon', style: { display: 'none' } },
			{ id: 'branch_data-red-input', style: { borderColor: '#ced4da' } },
			{ id: 'branch_data-red-input-2', style: { borderColor: '#ced4da' } },
			{ id: 'task-direction', style: { borderColor: '#ced4da' } },
		];

		if (event) {
			setBranchInformation(event.value);
			elements.forEach(({ id, style }) => {
				const el = document.getElementById(id);
				if (el) Object.assign(el.style, style);
			});
		} else {
			setBranchInformation(null);
		}
		
	};

	const setBranchInformation = (branch) => {
		setIdBranch(branch ? branch.id : null);
		setBranchName(branch ? branch.name : '');
		setBranchCompanyName(branch && branch.company ? branch.company.name : '');

		setClientLatitude(branch && branch.location ? branch.location.latitude : null);
		setClientLongitude(branch && branch.location ? branch.location.longitud : null);
		setClientTimeZone(branch && branch.location ? branch.location.timeZone : '');
		if(branch && branch.location){
			obtainDirectionData(branch.location.latitude, branch.location.longitud);
		}

		setIdClient(null);
	}

	
	/********************** Branch Search ***********************/
	const getBranchList = async (event) => {
		if (event.length > 0) {
			return await getBranchesByFilterAsyncSelectCreateTask(event, idAccount, user, getIdToken());
		}
	};

	const setFieldBranch = (event) => {
		const elements = [
			{ id: 'branch_data-alert-icon', style: { display: 'none' } },
			{ id: 'branch_data-red-input', style: { borderColor: '#ced4da' } },
			{ id: 'branch_data-red-input-2', style: { borderColor: '#ced4da' } },
			{ id: 'task-direction', style: { borderColor: '#ced4da' } },
		];

		if (event) {
			setBranchInformation(event.value);
			elements.forEach(({ id, style }) => {
				const el = document.getElementById(id);
				if (el) Object.assign(el.style, style);
			});
			getTaskTypes(event.value.id, null);
			getTaskPriority(event.value.id, null);
		} else {
			setBranchInformation(null);
		}
	};

	const getInitialOptionsBranch = async () => {
		return await getBranchesInitialOptionsAsyncSelect(idAccount, user, getIdToken());
	};

	/********************** Client Search ***********************/
	const getClientList = async (event) => {
		if (event.length > 0) {
			return await getClientsByFilterAsyncSelect(event, idAccount, user, getIdToken());
		}
	};
	
	const setFieldClients = (event) => {
	if (event) {
		const resetStyles = [
			{ id: 'client_data-alert-icon', style: { display: 'none' } },
			{ id: 'client_data-red-input', style: { borderColor: '#ced4da' } },
			{ id: 'client_data-red-input-2', style: { borderColor: '#ced4da' } },
			{ id: 'client_data-red-input-3', style: { borderColor: '#ced4da' } },
			{ id: 'client_data-red-input-4', style: { borderColor: '#ced4da' } },
			{ id: 'task-direction', style: { borderColor: '#ced4da' } },
		];

		resetStyles.forEach(({ id, style }) => {
			const el = document.getElementById(id);
			if (el) Object.assign(el.style, style);
		});

		const client = event.value;
		setClientInformation(client);
		getTaskTypes(null, client.idUser);
		getTaskPriority(null, client.idUser);
	} else {
		setClientInformation(null);
	}
};

	const getInitialOptionsClient = async () => {
		return await getClientInitialOptionsAsyncSelect(idAccount, idUser, getIdToken());
	};

	const setClientInformation = (user) => {
		setIdClient(user ? user.idUser : null);
		setClientName(user ? user.name : '');
		setClientLastName(user ? user.lastName : '');
		setClientMovileNumber(user ? user.mobileNumber : '');
		setClientEmail(user ? user.email : '');

		setClientLatitude(user && user.location ? user.location.latitude : null);
		setClientLongitude(user && user.location ? user.location.longitud : null);
		setClientTimeZone(user && user.location ? user.location.timeZone : '');
		if(user && user.location){
			obtainDirectionData(user.location.latitude, user.location.longitud);
		}
		setIdBranch(null);
	}

	/********************************* Team ***************************************/
	const [idTeam, setIdTeam] = useState(null);

	const getTeamList = async (event) => {
		if (event.length > 0) {
			return await getTeamsByFilterAsyncSelect(event, idAccount, idUser, getIdToken(), lan);
		}
	};

	const setFieldTeam = (event) => setIdTeam(event?.value?.id ?? null);

	const getInitialOptionsTeam = async () => {
		return await getTeamsInitialOptionsAsyncSelect(idAccount, idUser, getIdToken(), lan);
	};

	/****************************************************************************/

	const taskStatus = task.status;
	const isInStatus = [
		TaskStatus.EXECUTING,
		TaskStatus.FINISH,
		TaskStatus.CANCEL,
		TaskStatus.START_ROUTE,
		TaskStatus.CANCEL_BY_PARTNER,
	].includes(taskStatus);

	const isClientUser = session.user?.role === 'Fielder Client User';
	const isPartnerUser = session.user?.role && session.user.role !== 'Fielder Client User';
	const disableAutoCompleteMap = !!task.group ||
		(isInStatus && task.group == null && (
			(isClientUser && taskStatus !== TaskStatus.CANCEL_BY_PARTNER) ||
			isPartnerUser
		));
	

	const [idBranch, setIdBranch] = useState(task.branch?.id ?? null);
	const [branchName, setBranchName] = useState(task.branch?.name ?? '');
	const [branchCompanyName, setBranchCompanyName] = useState(task.branch?.company?.name ?? '');

	
	const [idClient, setIdClient] = useState(task.user?.idUser ?? null);
	const [clientName, setClientName] = useState(task.user?.name ?? '');
	const [clientLastName, setClientLastName] = useState(task.user?.lastName ?? '');
	const [clientMovileNumber, setClientMovileNumber] = useState(task.user?.mobileNumber ?? '');
	const [clientEmail, setClientEmail] = useState(task.user?.email ?? '');
	
	/***************************  Location Data   ********************************/	
	const [state, setState] = useState(task.startLocation.state);
	const [country, setCountry] = useState(task.startLocation.country);
	const [postalCode, setPostalCode] = useState(task.startLocation.postalCode);
	const [municipality, setMunicipality] = useState(task.startLocation.municipality);
	const [clientTimeZone, setClientTimeZone] = useState(task.startLocation.timeZone);
	const [taskNewDirection, setTaskNewDirection] = useState(task.startLocation.address);

	const [clientLatitude, setClientLatitude] = useState(parseFloat(task.startLocation.latitude));
	const [clientLongitude, setClientLongitude] = useState(parseFloat(task.startLocation.longitud));

	const [taskTypes, setTaskTypes] = useState({
		taskTypes: [],
		taskTypeList: [],
		taskTypeSelected: null,
	});

	const hideOnTaskGroup = task.group ? true : false;
	const disabledAllInput = task.group ? true : false;
	const executeCounter = (task.status == TaskStatus.REVIEW && task.serviceTypeId == FielderConst.TASK_BY_MAIL) ? true : false;
	
	const [taskType, setTaskType] = useState(task.serviceTypeId);
	const [firstTime, setFirstTime] = useState(true);
	const [showWarningAddress, setShowWarningAddress] = useState(false);


	/***************************  Task Priority   ********************************/
	const getTaskPriority = (idBranch, idClient, defaultPriority) => {
		console.log("defaultPriority")
			console.log(defaultPriority)
		const onSuccess = (response) => {
			const taskPriorityResponse = response.taskPriority ?? [];
			
			const hasValidId = (idBranch > 0) || (idClient > 0);
			const severityValue = hasValidId
				? (
					taskPriorityResponse.some(p => p.id === defaultPriority)
				? defaultPriority
					: (taskPriorityResponse[0]?.id ?? 3)
				)
					: (defaultPriority ?? 3);

			console.log("hasValidId")
			console.log(hasValidId)

			console.log("severityValue")
			console.log(severityValue)
			setTaskPriorities(taskPriorityResponse);
			setDefaultPriority(severityValue);
		};

		const onError = () => {
			setTaskPriorities(getDefaultPriorities(lan));
		};

		const body = { idBranch, idClient };
		const loadingConfig = { dispatch, config: { allowTopBar: true } };
		getTaskPriorityByOriginRequest(body, onSuccess, onError, loadingConfig);
	};


	/***************************  Task Type   ********************************/
	const validateReviewType = (taskTypes = []) => 
		(taskTypes.length && mailIntegrationFunctionality && taskStatus === TaskStatus.REVIEW)
			? [
				...taskTypes,
				{
				id: 100001,
				key: 100001,
				value: 100001,
				name: lan.tasktipeMail,
				title: lan.tasktipeMail,
				hours: '0 hrs',
				minutes: '32 min',
				parent: 0,
				children: null,
				routeVariables: null,
				status: true,
				disabled: true,
				}
			]
			: taskTypes;
	
	const validateListType = (taskTypeList = []) => 
		(taskTypeList.length && mailIntegrationFunctionality && taskStatus === TaskStatus.REVIEW)
			? [
				...taskTypeList,
				{
				hideToAgent: false,
				id: 100001,
				name: lan.tasktipeMail,
				originIds: { companies: null, branches: null, clients: null, applyToAll: true },
				origins: { companies: null, branches: null, clients: null },
				parent: null,
				price: null,
				routeVariables: [],
				status: true,
				time: 3660,
				}
			]
    : taskTypeList;

	const initTaskType = (taskTypeSelected, taskTypesObject) => {
    	let selected = taskTypeSelected;

		if (firstTime ) {
			selected = taskTypesObject.taskTypeList.find((type) => type.id === taskType);
		}
	
		updateSelectedTaskType(selected, true, taskTypesObject) ;
	};

	const updateSelectedTaskType = (selectedType, changeTypeVal, taskTypesObject) => {
		if (!selectedType || !taskTypesObject) return;

		const routeVars = checkTaskTypeRouteVariables(
			session.accountPreferences,
			taskTypesObject.taskTypeList,
			selectedType
		);
		/*setTaskTypes((prev) => ({
			...prev,
			taskTypeSelected: selectedType,
		}));*/
		taskTypesObject.taskTypeSelected= selectedType;
		setTaskTypes(taskTypesObject);
	
		setHasRouteVariables(routeVars);


		if (!firstTime) {
			setTaskType(selectedType.id);	
		}
		
		updateFirst(changeTypeVal);
	};
	
	const updateFirst = (changeTypeVal) => {
		if (changeTypeVal) setFirstTime(false);
	}

	const getTaskTypes = (idBranch, idClient) => {
		if (taskTypeFunctionality) {
			const setTaskTypeVariables = (accountTaskTypes, hasRouteVariables) => {
				let taskTypesObject = {
					taskTypes: validateReviewType(accountTaskTypes.taskTypes),
					taskTypeList: validateListType(accountTaskTypes.taskTypeList),
					taskTypeSelected: accountTaskTypes.taskTypeSelected,
				}
	
				setHasRouteVariables(hasRouteVariables);
				initTaskType( mailIntegrationFunctionality && taskStatus === TaskStatus.REVIEW ? 100001 :accountTaskTypes.taskTypeSelected, taskTypesObject );
			};
			getAccountTaskTypes(
				session.accountPreferences,
				idBranch,
				idClient,
				null,
				lan,
				setTaskTypeVariables
			);
		}
	};

	/***************************  Initialize   ********************************/
	const initialize = useCallback(() => {
		getTaskPriority(idBranch, idClient, defaultPriority);
		getTaskTypes(idBranch, idClient);
		if (!RoleUtils.isUserClient(session.user) && iAmNotPartner == true) {
			const branchCheckbox = document.getElementById('checkbox-branch');
			if (branchCheckbox) {
				branchCheckbox.disabled = disabledAllInput;
			}

			const clientCheckbox = document.getElementById('checkbox-client');
			if (clientCheckbox) {
				clientCheckbox.disabled = disabledAllInput;
			}
		}
	}, []);
	
	useEffect(() => {
		initialize();
	}, [initialize]);


	
	/***************************  Obtain Direction Data   ********************************/
	const obtainDirectionData = async (clientLatitude, clientLongitude) => {
		try {
			const response = await fromLatLng(clientLatitude, clientLongitude);
			const result = response.results?.[0];
			if (!result) return;

			const address = result.formatted_address;
			const components = result.address_components || [];

			const getComponent = (types) =>
				components.find((c) => types.some((t) => c.types.includes(t)))?.long_name || '';

			const state = getComponent(['administrative_area_level_1']);
			const country = getComponent(['country']);
			const postalCode = getComponent(['postal_code']);
			const municipality = getComponent([
			'administrative_area_level_2',
			'locality',
			'sublocality_level_1',
			]);

			setTaskNewDirection(address);
			setState(state);
			setCountry(country);
			setPostalCode(postalCode);
			setMunicipality(municipality);
		} catch (error) {
			console.error('Error obtaining direction data:', error);
		}
	};

	const onPlaceSelected = (place) => {
		if (!place) return;
		document.getElementById('task-direction').style.borderColor = '#ced4da';

		const { address, coordinates: { lat, lng }, country, state, postalCode, municipality } = place;

		setState(state);
		setCountry(country);
		setPostalCode(postalCode);
		setMunicipality(municipality);
		setTaskNewDirection(address);
		setClientLatitude(lat);
		setClientLongitude(lng);
		setShowWarningAddress(true);
	};



	/***************************  Validations   ********************************/
	const validateBranchAndClient = (idBranchAux, idClientAux) => {
		if(idBranchAux !== null || idClientAux !== null){
			outlineField('branch-name', true);
			outlineField('branch-company-name', true);
			outlineField('client-name', true);
			outlineField('client-lastname', true);
			outlineField('client-mobile', true);
			outlineField('client-email', true);			
			return true
		} else {
			outlineField('branch-name', false);
			outlineField('branch-company-name', false);
			outlineField('client-name', false);
			outlineField('client-lastname', false);
			outlineField('client-mobile', false);
			outlineField('client-email', false);		
			return false;	
		}
	}

	const validateTypeTask = (taskTypeAux) => {
		if (taskTypeAux !== null) {
			outlineFieldType('task-type-tree-select', true);
			return true;
		} else {
			outlineFieldType('task-type-tree-select', false);
			return false;
		}
	};

	const validatePriority = (priorityAux) => {
		if (priorityAux !== null) {
			outlineField('priority-select', true);
			return true;
		} else {
			outlineField('priority-select', false);
			return false;
		}
	};

	const validateDirection = (direction) => {
		const inputField = document.getElementById('task-direction');
		if (direction && direction.trim() !== '') {
			outlineField('task-direction', true);
			return true;
		} else {
			outlineField('task-direction', false);
			return false;
		}
	};

	const validateDescription = (description) => {
		if(description && description.trim() !== ''){
			outlineField('task-description', true);
			return true;
		} else {
			outlineField('task-description', false);
			return false;
		}
	};

	const outlineField = (fieldId, isValid) => {
		const inputField = document.getElementById(fieldId);
		if(!inputField) return;
		const outline = inputField
			.closest('.MuiOutlinedInput-root')
			?.querySelector('.MuiOutlinedInput-notchedOutline');
		
		outline.style.borderColor = isValid ? '' : '#c70101';
	}

	const outlineFieldType = (fieldId, isValid) => {
		const treeSelect = document.getElementById(fieldId);
		if (!treeSelect) return;

		const selector = treeSelect.querySelector('.ant-select-selector') 
					|| treeSelect.closest('.ant-select')?.querySelector('.ant-select-selector');
		if (!selector) return;

		selector.style.borderColor = isValid ? '' : '#c70101';
	};

	const validateChangeAddress = (originalLocation, clientLatitude, clientLongitude) => {
		const originLatitude = parseFloat(originalLocation.latitude);
		const originLongitud = parseFloat(originalLocation.longitud);
		return originLatitude !== clientLatitude || originLongitud !== clientLongitude;
	};
	
	/***************************  Handle Update Task   ********************************/
	const handleDoActionUpdateTask = (e) => {
		e.preventDefault();
		if(!validateDescription(description)){
			document.getElementById('register-form-hint').style.display = 'inline';
			return;
		}
		if(!validatePriority(priorityRef.current)){
			document.getElementById('register-form-hint').style.display = 'inline';
			return;
		} 
		if(!validateBranchAndClient(idBranch, idClient)){
			document.getElementById('register-form-hint').style.display = 'inline';
			return;
		}
	
		if(!validateTypeTask(taskType)){
			document.getElementById('register-form-hint').style.display = 'inline';
			return;
			
		}

		if(!validateDirection(taskNewDirection)){
			document.getElementById('register-form-hint').style.display = 'inline';
			return;
		}

		document.getElementById('register-form-hint').style.display = 'none';
		
		if (mailIntegrationFunctionality && taskStatus == TaskStatus.REVIEW && taskType == FielderConst.TASK_BY_MAIL) {
			document.getElementById('taskType-form-hint').style.display = 'inline';
			return;
		}
		document.getElementById('taskType-form-hint').style.display = 'none';
		
	
		if (mailIntegrationFunctionality && taskStatus == TaskStatus.REVIEW &&
				taskType == FielderConst.TASK_BY_MAIL && RoleUtils.isUserManager(user) && idTeam == null) {
			document.getElementById('idTeam-form-hint').style.display = 'inline';
		} 
		document.getElementById('idTeam-form-hint').style.display = 'none';
		
	
		let startDateTimeRange = null;
		let endDateTimeRange = null;
		let initialDate = null;
		let endDate = null;

		if(executionDateRef.current != null){
			if(executionDateRef.current[0] != null && executionDateRef.current[1] != null){
				const initialTempDate = executionDateRef.current[0];
		
				initialDate = {
					startRangeYear: initialTempDate.year(),
					startRangeMonth: initialTempDate.month(),
					startRangeDay: initialTempDate.date(),
					startRangeHour: initialTempDate.hour(),
					startRangeMinute: initialTempDate.minute(),
				};

				const endTempDate = executionDateRef.current[1];

				endDate = {
					endRangeYear: endTempDate.year(),
					endRangeMonth: endTempDate.month(),
					endRangeDay: endTempDate.date(),
					endRangeHour: endTempDate.hour(),
					endRangeMinute: endTempDate.minute(),
				};

				startDateTimeRange = initialTempDate.valueOf();
				endDateTimeRange = endTempDate.valueOf();
			}
		}

	
		let user = null;
		if(idClient != null){
			user = {
				idUser : idClient,
			};
		}
		let branch = null;
		if(idBranch != null){
			branch = {
				id: idBranch,
			};
		}
		
		let body = {
			taskInfo:{
				startRangeHour: initialDate ? initialDate.startRangeHour : null,
				startRangeMinute: initialDate ? initialDate.startRangeMinute : null,
				startRangeDay: initialDate ? initialDate.startRangeDay : null,
				startRangeMonth: initialDate ? initialDate.startRangeMonth : null,
				startRangeYear: initialDate ? initialDate.startRangeYear : null,
				endRangeHour: endDate ? endDate.endRangeHour : null,
				endRangeMinute: endDate ? endDate.endRangeMinute : null,
				endRangeDay: endDate ? endDate.endRangeDay : null,
				endRangeMonth: endDate ? endDate.endRangeMonth : null,
				endRangeYear: endDate ? endDate.endRangeYear : null,

				task: {
					idTask: idTask,
					idAccount: idAccount,
					startTimeSort: task.startTimeSort,
					startTime: task.startTime,
					createTime: task.createTime,

					// Date Range
					startDateTimeRange: startDateTimeRange,
					endDateTimeRange: endDateTimeRange,

					// Main Info
					description: description,
					status: taskStatus,
					severity: priorityRef.current,
					serviceTypeId: taskType,
					folio: folio,
					caseNumber:  numberCaseRef.current ?  numberCaseRef.current : null,
					
					// Client & Branch
					user: user,
					branch: branch,
					
					startLocation: {
						idLocation: task.startLocation.idLocation,
						address: taskNewDirection,
						state: state,
						country: country,
						postalCode: postalCode,
						latitude: clientLatitude,
						longitud: clientLongitude,
						municipality: municipality,
						timeZone: task.startLocation.timeZone,
					},
					// Tags
					tags:  tagsRef && tagsRef.current != null ? tagsRef.current.map(item => item.label): null,
					idTeam: idTeam
				},
				routeVariables: routeVariablesRef.current,
				updateAdress: validateChangeAddress(task.startLocation,clientLatitude, clientLongitude)
				}
			};
	
		const loadingConfig = { dispatch };
		const onSuccess = () => props.onCloseModal(executeCounter);
		console.log(body);
		updateTaskRequest(body, onSuccess, null, loadingConfig);
	};

	return (
		<Grid container spacing={2}>
			{/* First Half of the page */}
			<Grid size={{ xs: 12, md: 6, lg: 6 }}>
				{isNotAClient && iAmNotPartner && (
					<Box sx={{ mt: 1 }}><span>{lan.select}</span></Box>
				)}
				{isUserClient && user.branches != null && (
					<Box sx={{ mt: 1 }}><span>{lan.select + ' ' + lan.branch} </span></Box>
				)}
				{isUserClient && user.branches != null && (
					<Box sx={{ mt: 1 }}>
						<Select
							defaultValue={
								idBranch != null
									? clientBranches.filter((option) => validateBranchesArray(option.value.id))
									: null
							}
							cacheOptions
							defaultOptions
							options={clientBranches}
							onChange={setClientBranchId}
							placeholder={lan.placeHolderBranch}
							className='full-width mb-1'
              classNamePrefix="smart-select"
							isSearchable={true}
							isClearable={false}
						/>
					</Box>
				)}

				<Grid container>
					<Grid size={6}>
						{isNotAClient && iAmNotPartner && (
							<Paper
								hidden={false}
								sx={{
									m: 1,
									p: 1.5,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									gap: 1.25,
									whiteSpace: 'nowrap',
								}}
							>
								<input
									type='checkbox'
									className='form-check-input labelCheckbox d-none'
									id='checkbox-branch'
									name='checkbox-branch'
									ref={cbBranchRef}
									checked={showBranchSearch}
								/>
								<label
									htmlFor='checkbox-branch'
									className='square-checkbox ml-2'
									onClick={() => {
										if (cbClientRef.current) {
											cbClientRef.current.checked = false;
										}
										setShowClientSearch(false);
										setShowBranchSearch(true);
									}}
								/>
								 <Box component="span" className="tag" sx={{ mb: 1 }}>{lan.branch}</Box>						
							</Paper>
						)}
					</Grid>
					<Grid size={6}>
						{isNotAClient && iAmNotPartner && (
								<Paper
									hidden={hideOnTaskGroup}
									sx={{
									m: 1,
									p: 1.5,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									gap: 1.25,
									whiteSpace: 'nowrap',
									}}
								>
								
								<input
									type='checkbox'
									className='form-check-input labelCheckbox d-none'
									id='checkbox-client'
									name='checkbox-client'
									ref={cbClientRef}
									checked={showClientSearch}
								/>
								<label
									htmlFor='checkbox-client'
									className='square-checkbox ml-2'
									onClick={() => {
										if (cbBranchRef.current) {
											cbBranchRef.current.checked = false;
										}
										setShowClientSearch(true);
										setShowBranchSearch(false);
									}}
								/>
								<Box component="span" className="tag" sx={{ mb: 1 }}>{lan.client}</Box>
							</Paper>
						)}
					</Grid>
				</Grid>

				{isNotAClient && iAmNotPartner && (
					<Box sx={{ mt: 1, mb: 1 }}><span>{lan.searchBy}</span></Box>
				)}

				<Grid container>
					{showBranchSearch && isNotAClient && iAmNotPartner && (
						<Grid size={12}>
							<AsyncSearch
								className='react-select__control full-width mb-1'
								getOptions={getBranchList}
								onChange={setFieldBranch}
								label={lan.placeHolderBranch}
								lan={lan}
								disabled={disabledAllInput}
								id='select-add-branch'
								showInitialOptions
								getInitialOptions={getInitialOptionsBranch}
							/>
						</Grid>
					)}


					{(showBranchSearch || (isUserClient && user.branches)) && (
						<>
							<Grid size={12} sx={{ pt: 2, pb: 1}}>
								<EditTaskField id={'branch-name'} value={branchName} label={lan.nameBranch} disabled={true} />
							</Grid>
							<Grid size={12} sx={{ pt: 2, pb: 1}}>
								<EditTaskField id={'branch-company-name'} value={branchCompanyName} label={lan.nameCompany} disabled={true} />
							</Grid>
						</>
					)}
				</Grid>

				<Grid container>
					{showClientSearch && isNotAClient && iAmNotPartner && (
						<Grid size={12}>
							<AsyncSearch
                fullWidth
								getOptions={getClientList}
								onChange={setFieldClients}
								label={lan.placeHolderClient}
								lan={lan}
								disabled={disabledAllInput}
								id='select-add-client'
								showInitialOptions
								getInitialOptions={getInitialOptionsClient}
							/>
						</Grid>
					)}

					{(showClientSearch || (isUserClient && !user.branch)) && (
						<Grid size={12}>
							<Grid container spacing={2} sx={{ mt: 2 }}>
								<Grid size={6}>
									<EditTaskField id={'client-name'} value={clientName} label={lan.nameClient} disabled={true} />
								</Grid>
								<Grid size={6}>
									<EditTaskField id={'client-lastname'} value={clientLastName} label={lan.lastNameClient} disabled={true} />
								</Grid>
								<Grid size={6}>
									<EditTaskField id={'client-mobile'} value={clientMovileNumber} label={lan.cellphoneClient} disabled={true} />
								</Grid>
								<Grid size={6}>
									<EditTaskField id={'client-email'} value={clientEmail} label={lan.emailClient} disabled={true} />
								</Grid>
							</Grid>
						</Grid>
					)}
				</Grid>

				{validateShowTeam && (
					<Grid container>
						<Box sx={{ mt: 1 }}><span> {lan.team} </span></Box>
						<AsyncSearch
							fullWidth
							getOptions={getTeamList}
							onChange={setFieldTeam}
							label={lan.placeHolderTeam}
							lan={lan}
							id='all-AsyncSearch'
							showInitialOptions
							getInitialOptions={getInitialOptionsTeam}
						/>
					</Grid>
				)}

				<Box sx={{ mt: 1 }} id='col-task-taskType'>
					<SelectTaskType
						taskTypeOptions={taskTypes}
						updateTaskType={(e) => updateSelectedTaskType(e,true, taskTypes)}
						selectedType={taskTypes.taskTypeSelected}
						dontUseMargin={true}
						dontExecuteSelectedAction={true}
					/>
				</Box>
				<Box sx={{ pl: 1, mt: 1, mb: 1 }} id='col-map'>
					<MapStaticComponent size='500x200'>
						<StaticMarker
							location={{
								lat: parseFloat(clientLatitude),
								lng: parseFloat(clientLongitude),
							}}
							icon={props.taskData.taskPin}
						/>
					</MapStaticComponent>
				</Box>
				<Box sx={{ mt: 2 }} id='col-task-direction'>
					{showWarningAddress && (
            <Alert icon={false} severity='warning' sx={{ mb: 1}}>
              {lan.warningAddress}
            </Alert>
					)}

					<GoogleMapsAutocomplete
						id='task-direction'
						fullWidth
						label={lan.directionClient}
						onSelect={onPlaceSelected}
						value={taskNewDirection}
						disabled={disableAutoCompleteMap}
					/>
				</Box>
			</Grid>

			{/* Second Half of the Page */}
			<Grid size={{ xs: 12, md: 6, lg: 6 }}>
				<Box sx={{ mt: 1, mb: 2 }}>
					<EditTaskField id={'id-task-edit'} value={idTask} label={lan.idFielder} disabled={true} />
				</Box>
				<Box sx={{ mt: 2, mb: 2 }}>
					<EditTaskField id={'id-task-custom'} value={idCustomTask} label={lan.customId} disabled={true} />
				</Box>
				<Box sx={{ mt: 2, mb: 1 }}>
					<EditTaskField id={'id-task-folio'} onChange={(e) => setFolio(e.target.value)} value={folio} label={lan.folio} />
				</Box>
				<TaskCaseNumber  ref={numberCaseRef} caseNumberValue={caseNumber} />
				<Box sx={{ mt: 1, mb: 1 }}>
					<TaskPriority useMargin={true} ref={priorityRef} createClicked={null} taskPriorities={taskPriorities} defultPriority={defaultPriority } />
				</Box>
				<Box sx={{ mt: 1, mb: 2 }}>
						<TaskExecutionDates executionDatesAux={executionDates} ref={executionDateRef} disabled={false} />
				</Box>
				<Box sx={{ mt: 2, mb: 1 }}>
						<EditTaskField id={'task-description'} rows={5} onChange={(e) => setDescription(e.target.value)} value={description} label={lan.description} disabled={false} />
				</Box>
				<Box sx={{ mt: 1 }}>
					<TaskTags ref={tagsRef} tagsDataAux={tags} />
				</Box>
				<TaskVariables
					hasRouteVariables={hasRouteVariables}
					taskType={taskTypes.taskTypeSelected}
					ref={routeVariablesRef}
					isNotAClient={isNotAClient}
				/>
				<div id='register-form-hint' className='Register-form-hint mt-3'>
					<p>*{lan.requiredFields}</p>
				</div>
				<div id='taskType-form-hint' className='Register-form-hint mt-2'>
					<p>*{lan.requiredTaskType}</p>
				</div>
				<div id='idTeam-form-hint' className='Register-form-hint mt-2'>
					<p>*{lan.requiredTeam}</p>
				</div>
				<Grid size={12} sx={{ p: 3}}>
					<Button
            variant="contained"
            onClick={(e) => handleDoActionUpdateTask(e)}
            size={'large'}
            fullWidth
          >
						{lan.save}
					</Button>
				 </Grid>
			</Grid>

		</Grid>
	);	
}

export default EditorTask;
